import * as types from "../actions/types/card.types";

const initialState = {
    getCustomerCardsState: "loading",
    getCardDeliveryCharges: "loading",
    customerDebitCards: [],
    pickupLocation: [],
    activeSelectionIndex: 0,
    activeSelection: {},
};

export const cardsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_CUSTOMER_CARDS_STARTED:
            return {
                ...state,
                getCustomerCardsState: "loading",
            };
        case types.FETCH_CUSTOMER_CARDS_SUCCEEDED: {
            const filtered = action.payload.filter(({ status }) => status !== 8);

            return {
                ...state,
                getCustomerCardsState: "success",
                customerDebitCards: filtered,
            };
        }
        case types.FETCH_CUSTOMER_CARDS_FAILED:
            return {
                ...state,
                getCustomerCardsState: "failed",
            };

        case types.GET_DELIVERY_CHARGES_SUCCESS:
            return {
                ...state,
                getCardDeliveryCharges: "success",
                pickupLocation: [...action.payload],
            };
        case types.SET_ACTIVE_SELECTION:
            return {
                ...state,
                activeSelection: action.payload,
            };
        case types.SET_ACTIVE_SELECTION_INDEX:
            return {
                ...state,
                activeSelectionIndex: action.payload,
            };
        default:
            return state;
    }
};
